var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#555555;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4,28.6h59c0.5,0,0.9-0.4,0.9-0.9V17.5c0-0.5-0.4-0.9-0.9-0.9h-59c-0.5,0-0.9,0.4-0.9,0.9v10.2 C38.4,28.2,38.9,28.6,39.4,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4,56h59c0.5,0,0.9-0.4,0.9-0.9V44.9c0-0.5-0.4-0.9-0.9-0.9h-59c-0.5,0-0.9,0.4-0.9,0.9v10.2 C38.4,55.6,38.9,56,39.4,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4,83.4h59c0.5,0,0.9-0.4,0.9-0.9V72.3c0-0.5-0.4-0.9-0.9-0.9h-59c-0.5,0-0.9,0.4-0.9,0.9v10.2 C38.4,83,38.9,83.4,39.4,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,58v21.1l7.3-0.2c3.4,0,5.2,4.2,2.7,6.6L19.3,98.2c-1.5,1.5-3.9,1.5-5.4,0L1.1,85.5 c-2.4-2.4-0.7-6.6,2.7-6.6l7.3,0.2V58c0-1.4,1.2-2.6,2.6-2.6l5.8,0C20.9,55.5,22,56.6,22,58z M11.1,42l0-21.1l-7.3,0.2 c-3.4,0-5.2-4.2-2.7-6.6L13.9,1.8c1.5-1.5,3.9-1.5,5.4,0L32,14.5c2.4,2.4,0.7,6.6-2.7,6.6L22,20.9V42c0,1.4-1.2,2.6-2.6,2.6h-5.8 C12.3,44.5,11.1,43.4,11.1,42L11.1,42z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.a3ec095d85e7ec03c82db50308bdea39.svg";
export { ForwardRef as ReactComponent };